import { FaClock, FaMapMarkerAlt, FaUserTie, FaDollarSign, FaTags, FaBriefcase, FaCalendarAlt, FaPhone, FaUsers, FaEnvelope, FaComments, FaHourglass, FaChartArea, FaWifi, FaBed, FaMoneyBillWave, FaLeaf, FaMountain, FaChartLine, FaHiking, FaCalendarCheck, FaCalendarTimes, FaUser, FaChild, FaUserAlt, FaShuttleVan, FaCompass, FaSuitcaseRolling, FaBinoculars, FaRunning, FaFish } from 'react-icons/fa';
import { FaPersonHiking, FaTent, FaTents } from 'react-icons/fa6';



// Function to render the appropriate icon based on the service name
export const renderIcon = (iconName) => {

  // Convert the service name to lowercase
  const lowercaseServiceName = iconName.toLowerCase();

  // Check the lowercase service name and return the corresponding icon component
  switch (lowercaseServiceName) {

    /*----- Service Icons -----*/
    case 'guided hikes':
      return <FaPersonHiking />; // Hiking icon

    case 'camping excursions':
      return <FaTents />; // Tent icon

    case 'wilderness survival':
      return <FaCompass />; // Compass icon

    case 'group expeditions':
      return <FaUsers />; // Group icon

    case 'equipment rental':
      return <FaSuitcaseRolling />; // Luggage icon

    case 'adventure tours':
      return <FaBinoculars />; // Binoculars icon

    /*----- Activities Icons -----*/
    case 'hiking':
      return <FaHiking />; // Hiking icon

    case 'camping':
      return <FaTent />; // Tent icon

    case 'rock climbing':
      return <FaMountain />; // Mountain icon

    case 'wildlife viewing':
      return <FaBinoculars />; // Binoculars icon

    case 'trail running':
      return <FaRunning />; // Running icon

    case 'fishing':
      return <FaFish />; // Fish icon

    /*----- Page Sidebar -----*/
    case 'date':
    case 'days':
    case 'deadline':
      return <FaCalendarAlt />; // Calendar icon

    case 'timing':
    case 'hours':
    case 'time':
    case 'idealduration':
      return <FaClock />; // Clock icon

    case 'duration':
      return <FaHourglass />; // Hourglass icon

    case 'client':
    case 'position':
    case 'peoplecapacity':
      return <FaUsers />; // Users icon

    case 'category':
      return <FaTags />; // Tags icon

    case 'location':
    case 'venue':
      return <FaMapMarkerAlt />; // Location icon

    case 'salary':
    case 'cost':
    case 'entryfee':
    case 'reservationcost':
    case 'budget':
    case 'price':
      return <FaDollarSign />; // Dollar icon

    case 'experience':
      return <FaBriefcase />; // Briefcase icon

    case 'leadguide':
    case 'organizer':
      return <FaUserTie />; // Leader icon

    case 'number':
      return <FaPhone />; // Phone icon

    case 'email':
      return <FaEnvelope />; // Email icon

    case 'size':
      return <FaChartArea />; // Area chart icon

    case 'wifi':
      return <FaWifi />; // Wi-Fi icon

    case 'bedrooms':
      return <FaBed />; // Bed icon

    case 'terraintype':
      return <FaMountain />; // Mountain icon

    case 'elevationrange':
      return <FaChartLine />; // Line chart icon

    case 'languagespoken':
      return <FaComments />; // Comments icon

    case 'currency':
      return <FaMoneyBillWave />; // Money icon

    case 'bestseason':
      return <FaLeaf />; // Leaf icon

    case 'tourtype':
      return <FaHiking />; // Hiking icon

    case 'checkin':
      return <FaCalendarCheck />; // Check-in icon

    case 'checkout':
      return <FaCalendarTimes />; // Check-out icon

    case 'person':
      return <FaUser />; // User icon

    case 'minage':
      return <FaChild />; // Child icon

    case 'maxage':
      return <FaUserAlt />; // Adult icon

    case 'accommodation':
      return <FaTent />; // Tent icon

    case 'transportation':
      return <FaShuttleVan />; // Van icon

    default:
      return null; // Return null if no matching icon is found
  }

};